module.exports = __webpack_public_path__ + "static/media/gas_cylinder.5cbad160.svg";